import React from 'react'
import { number, string, oneOfType } from 'prop-types'
import { FormattedNumber } from 'react-intl'

const getProps = (props) => {
  switch (props.currency) {
    case 'JPY':
      return { ...props, ...{ minimumFractionDigits: 0, maximumFractionDigits: 0 } }
    default:
      return props
  }
}

export const Currency = (props) => {
  return <FormattedNumber {...getProps(props)} />
}

Currency.propTypes = {
  currency: string,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  value: oneOfType([string, number]),
}

Currency.defaultProps = {
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'currency',
  value: 0,
}
